import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {PixKeyCheckResponse} from '@gatewee/types/pix-key-check';
import {PixKeyType} from '@gatewee/types/recipient-bank-account';
import {Observable} from 'rxjs';

/** Domain-scoped PIX DICT lookup (unlike the recipient app, the recipient id must be sent). */
@Injectable({
  providedIn: 'root',
})
export class PixDomainService {
  constructor(private readonly http: HttpClient) {}

  checkKey(
    recipientId: number,
    pixKey: string,
    pixKeyType: PixKeyType,
  ): Observable<PixKeyCheckResponse> {
    return this.http.post<PixKeyCheckResponse>('/pix/domain/check-key', {
      recipient: {id: recipientId},
      pixKey,
      pixKeyType,
    });
  }
}
